<script>
  import router from './lib/router';
  import { onDestroy, onMount } from 'svelte';
  import APIClient from './state-charts/api-client';
  import { TS } from './config/translation-keys.js';
  import { t9n, set_language } from './lib/translate.js';
  import Layout from './app-shell/authorized-app/Layout.svelte';
  import FirstTimeRoleSelector from './profiles/FirsTimeRoleSelector.svelte';
  import { show_message } from './lib/flash';
  import session from './lib/session';
  import Shepherd from 'shepherd.js';
  import { check_tutorial, show_tutorial_screen } from './lib/tutorials';
  import settings from './config';

  // component options  ------------------------------------------------------ //

  export let route_name;
  export let query;
  // translated strings ------------------------------------------------------ //

  let pilot_points;
  let payments;
  let reports;
  let apps;
  let pend;
  let await_hexa;
  let apprv;
  let amount;
  let opps;
  let foryou;
  let inprog;
  let new_order_label;
  let workers_map;
  let history;
  let in_progress;
  let pp_digits;
  let orderer_initialized_orders_digits;
  let applicants_pending_digits;
  let pending_total_digits;
  let first_time_role_selector;
  let is_same_timezone;
  let has_init = false;

  // internal variables ------------------------------------------------------ //

  let first_time = false;
  let show_new_order = false;

  let api_group_orderer = ['unassigned', 'delivered'];

  let api_group_worker = ['opportunities', 'current'];

  let currency;

  let orderer_hexas = [
    {
      name: [payments],
      x_top: '62',
      y_top: '135',
      x_bottom: '70',
      y_bottom: '155',
      css:
        'home-hexa grow home-hexa-pilot hexa-pos-top hexa-pos-left hexa-margin-mobile-lg',
      href: '/cards',
      img: '/assets/credit_card.svg',
    },
    {
      name: [apps, pend],
      x_top: '60',
      y_top: '135',
      x_bottom: '70',
      y_bottom: '155',
      css:
        'home-hexa grow home-hexa-apps hexa-margin-top hexa-margin-mobile-sm',
      href: '/orders?group=0',
      img: '/assets/profile-white.svg',
    },
    {
      name: [in_progress],
      x_top: '70',
      y_top: '135',
      x_bottom: '69',
      y_bottom: '155',
      css:
        'home-hexa grow home-hexa-ongoing hexa-pos-top hexa-pos-right hexa-margin-mobile-sm',
      href: '/orders?group=1',
      img: '/assets/in_progress.svg',
    },
  ];

  let orderer_hexas2 = [
    {
      name: [workers_map],
      x_top: '52',
      y_top: '135',
      css:
        'home-hexa grow home-hexa-pilot hexa-pos-top hexa-pos-left2 hexa-margin-mobile-sm',
      href: `/workers-map`,
      img: '/assets/workers_map.svg',
    },
    {
      name: [history],
      x_top: '52',
      y_top: '135',
      css:
        'home-hexa grow home-hexa-ongoing hexa-pos-top hexa-pos-right2 hexa-margin-mobile-sm',
      href: '/orders?group=3',
      img: '/assets/history.svg',
    },
  ];

  let orderer_hexas3 = [
    {
      name: [await_hexa, apprv],
      x_top: '52',
      y_top: '135',
      x_bottom: '69',
      y_bottom: '155',
      css: 'home-hexa grow home-hexa-apps hexa-margin-mobile-sm',
      href: '/orders?group=2',
      img: '/assets/update_orderer.svg',
    },
  ];

  let worker_hexas = [
    {
      name: [payments],
      x_top: '62',
      y_top: '135',
      x_bottom: '70',
      y_bottom: '155',
      css:
        'home-hexa grow home-hexa-pilot hexa-pos-top hexa-pos-left hexa-margin-mobile-lg',
      href: '/cards',
      img: '/assets/credit_card.svg',
    },
    {
      name: [opps, foryou],
      x_top: '48',
      y_top: '135',
      x_bottom: '78',
      y_bottom: '155',
      css:
        'home-hexa grow home-hexa-apps hexa-margin-top hexa-margin-mobile-sm',
      href: '/orders?group=0',
      img: '/assets/profile-white.svg',
    },
    {
      name: [inprog],
      x_top: '58',
      y_top: '135',
      css:
        'home-hexa grow home-hexa-ongoing hexa-pos-top hexa-pos-right hexa-margin-mobile-sm',
      href: '/orders?group=1',
      img: '/assets/update.svg',
    },
  ];

  /* todo: Akos, this x_top solution is highly problematic with translations! */
  const modify_fin_texts = () => {
    orderer_hexas[1].x_top = '79';
    orderer_hexas[1].x_bottom = '75';
    orderer_hexas[2].x_top = '75';
    orderer_hexas[2].x_bottom = '55';

    worker_hexas[0].x_top = '38';
    worker_hexas[1].x_top = '44';
    worker_hexas[1].x_bottom = '82';
    worker_hexas[2].x_top = '61';
  };

  $: if ($session.language === 'fi') {
    modify_fin_texts();
  }

  // utility functions -------------------------------------------------------- //

  const translate_texts = () => {
    pilot_points = t9n(TS.MENU_LABEL_PILOT_POINTS);
    payments = t9n(TS.HOME_HEXA_PAYMENTS);
    reports = t9n(TS.HOME_HEXA_AND_REPORTS);

    apps = t9n(TS.TABLE_HEADER_APPS);
    pend = t9n(TS.HOME_HEXA_PEND);
    await_hexa = t9n(TS.HOME_HEXA_AWAIT);
    apprv = t9n(TS.HOME_HEXA_APPRV);
    amount = t9n(TS.HOME_HEXA_AMOUNT);
    opps = t9n(TS.TABLE_CHIP_OPPS);
    foryou = t9n(TS.HOME_HEXA_FORYOU);
    inprog = t9n(TS.TABLE_CHIP_IN_PROG);
    new_order_label = t9n(TS.HOME_BUTTON_NEW);

    workers_map = t9n(TS.MENU_LABEL_WORKERS_MAP);
    history = t9n(TS.TABLE_CHIP_HIST);
    in_progress = t9n(TS.TABLE_CHIP_IN_PROG);

    orderer_hexas[0].name = [payments, reports];
    orderer_hexas[1].name = [apps, pend];
    orderer_hexas[2].name = [in_progress];

    orderer_hexas2[0].name = [workers_map];
    orderer_hexas2[1].name = [history];

    orderer_hexas3[0].name = [await_hexa, apprv];

    worker_hexas[0].name = [payments, reports];
    worker_hexas[1].name = [opps, foryou];
    worker_hexas[2].name = [inprog];
  };

  const get_merchant_currency = () => {
    return $session.merchant.currency_sign;
  };

  const set_hexa_val = (index, hexa_val) => {
    let num = 0;
    let start = null;
    let duration = 500;

    const step = current_time => {
      if (!start) start = current_time;
      let elapsed_time = current_time - start;
      if (elapsed_time < duration) {
        num = Math.floor(hexa_val * (elapsed_time / duration));
        set_hexa_svg(index, num);
        window.requestAnimationFrame(step);
      } else {
        set_hexa_svg(index, hexa_val);
      }
    };

    window.requestAnimationFrame(step);
  };

  const set_hexa_svg = (index, num) => {
    let svg_x;
    let svg_num = document.getElementById('svg-num-' + index);

    if (svg_num) {
      svg_num.innerHTML = num ? num.toString() : '0';
      if (svg_x) {
        svg_num.setAttribute('x', svg_x);
      }
    }
  };

  const get_save_state = () => {
    let url_string = window.location.href;
    let url = new URL(url_string);
    return url.searchParams.get('save') === 'true';
  };

  const init_hexa_values_orderer = () => {
    applicants_pending_digits = Math.floor(
      $session.user.stats.applicants_pending
    ).toString().length;
    orderer_initialized_orders_digits = Math.floor(
      $session.user.stats.orderer_initialized_orders
    ).toString().length;

    if ($session.user.stats.pilot_points >= 100000) {
      pp_digits = 6;
    }
    if ($session.user.stats.pilot_points >= 1000000) {
      pp_digits = 7;
    }
    if ($session.user.stats.pilot_points >= 10000000) {
      pp_digits = 8;
    }
    if ($session.user.stats.pilot_points >= 100000000) {
      pp_digits = 9;
    }

    set_hexa_val(0, $session.user.stats.pilot_points);
    set_hexa_val(1, $session.user.stats.applicants_pending);
    set_hexa_val(4, $session.user.stats.orderer_delivered_orders);
    set_hexa_val(33, $session.user.stats.orderer_initialized_orders);
    set_hexa_val(2, $session.user.stats.orderer_in_progress_orders);
  };

  const init_hexa_values_worker = () => {
    set_hexa_val(0, $session.user.stats.amount_earned.toFixed(0));
    set_hexa_val(1, $session.user.stats.opportunities);
    set_hexa_val(2, $session.user.stats.worker_in_progress_orders);
  };

  const create_first_time_role_selector = () => {
    const target = document.querySelector('div[slot="content"]');

    if (target) {
      first_time_role_selector = new FirstTimeRoleSelector({
        target: document.querySelector('div[slot="content"]'),
        props: {
          open_on_load: true,
        },
      });
    }
  };

  const check_different_timezone = () => {
    let current_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return current_timezone === $session.merchant.timezone;
  };

  const check_for_first_time = user => {
    first_time = !user.is_orderer && !user.is_worker;

    if (first_time && !first_time_role_selector) {
      create_first_time_role_selector();
    }
  };

  function check_supported_browser() {
    let isChrome = false;
    let isFirefox = typeof InstallTrigger !== 'undefined';

    let isChromium = window.chrome;
    let winNav = window.navigator;
    let vendorName = winNav.vendor;
    let isOpera = typeof window.opr !== 'undefined';
    let isIEedge = winNav.userAgent.indexOf('Edg') > -1;
    let isIOSChrome = winNav.userAgent.match('CriOS');

    if (isIOSChrome) {
      isChrome = true;
    } else if (
      isChromium !== null &&
      typeof isChromium !== 'undefined' &&
      vendorName === 'Google Inc.' &&
      isOpera === false &&
      isIEedge === false
    ) {
      isChrome = true;
    }

    return !(isFirefox || isChrome);
  }

  const init_home = async () => {
    document
      .querySelector('.mdc-top-app-bar--fixed-adjust')
      .scrollIntoView({ behavior: 'smooth' });

    let show_unsupported_warning = check_supported_browser();
    if (
      show_unsupported_warning &&
      window.show_unsupported_warning === undefined
    ) {
      window.show_unsupported_warning = false;
      show_message(t9n(TS.UNSUPPORTED_BROWSER), 'action');
    }

    check_for_first_time($session.user);

    if (first_time) {
      $session.tutorial = await check_tutorial();
      window.localStorage.setItem('WP.tutorial', $session.tutorial);
      window.localStorage.setItem('WP.tutorial.new_order', $session.tutorial);
      show_tutorial_screen(
        $session.tutorial,
        'tour_w1',
        400,
        'no_role_yet',
        true
      );
    }

    if ($session.user.last_role === 'orderer') {
      init_hexa_values_orderer();
    } else {
      init_hexa_values_worker();
    }

    if (get_save_state() === true) {
      window.history.replaceState({}, document.title, '/home');
      show_message(t9n(TS.SETTINGS_LABEL_SAVED), 'success');
      show_tutorial_screen(
        JSON.parse(window.localStorage.getItem('WP.tutorial')),
        'tour_w5',
        1500,
        $session.user.last_role
      );
    } else {
      window.history.replaceState({}, document.title, '/home');
    }

    is_same_timezone = check_different_timezone();
  };

  const set_fin_amount_hexa = () => {
    worker_hexas[0].x_top = '72';
    worker_hexas[0].y_top = '135';
    worker_hexas[0].x_bottom = '79';
    worker_hexas[0].y_bottom = '155';
  };

  const new_order = () => {
    router.navigate('/order-new');
  };

  // reactive functions ------------------------------------------------------- //

  $: {
    translate_texts();

    if ($session.language === 'fi') {
      set_fin_amount_hexa();
    }
  }

  $: if (!!$session.merchant) {
    currency = get_merchant_currency();
  }

  $: if (
    !!$session &&
    !!session.user &&
    !!$session.user.last_role === 'orderer'
  )
    show_new_order = true;

  $: if (
    JSON.parse(window.localStorage.getItem('WP.tutorial_part2')) &&
    get_save_state() === false
  ) {
    show_tutorial_screen(
      JSON.parse(window.localStorage.getItem('WP.tutorial')),
      'tour_w5',
      1000,
      $session.user.last_role
    );
  }

  $: if($session.user.last_role){
    if($session.user.last_role === 'worker'){
      init_hexa_values_worker()
    } else {
      init_hexa_values_orderer()
    }
  }


  onMount(async () => {
    await init_home();
  });
</script>

<div>
  <main class="home-hexagons fade-in">

    {#if $session.user.last_role === 'orderer'}
      <div class="new-order-container">
        <button
          class="mdc-fab mdc-ripple-upgraded grow"
          id="new_order"
          aria-label="Favorite"
          style="--mdc-ripple-fg-size:33px; --mdc-ripple-fg-scale:2.70291;
          --mdc-ripple-fg-translate-start:25.0156px, 13.8945px;
          --mdc-ripple-fg-translate-end:11.5px, 11.5px;"
          on:click={new_order}>

          <div class="mdc-fab__ripple" />

          <i
            style="font-weight: bold;"
            class="mdc-fab__icon md-order-size material-icons">
            add
          </i>
        </button>

        <span class="new-order-text">{new_order_label}</span>
      </div>
    {/if}

    {#if $session.user.last_role === 'orderer'}
      <div>
        {#each orderer_hexas as hexa, i}
          <a data-link href={hexa.href}>
            <svg
              width="210"
              height="182"
              viewbox="0 0 210 181.8653347947321"
              class={hexa.css}>
              <path
                class="hexa-stroke"
                d="M2.5000000000000004 95.26279441628824Q0 90.93266739736605
                2.5000000000000004 86.60254037844385L50 4.330127018922193Q52.5 0
                57.5 0L152.5 0Q157.5 0 160 4.330127018922193L207.5
                86.60254037844385Q210 90.93266739736605 207.5
                95.26279441628824L160 177.5352077758099Q157.5 181.8653347947321
                152.5 181.8653347947321L57.5 181.8653347947321Q52.5
                181.8653347947321 50 177.5352077758099Z" />
              <!--{#if orderer_hexas[1]}-->

              {#if hexa.name[0] === apps}
                <text
                  id={'svg-num-1'}
                  x="30%"
                  y="107"
                  font-family="Roboto"
                  class="svg-num fade-in"
                  class:svg-num-8={applicants_pending_digits === 3}
                  class:svg-num-9={applicants_pending_digits === 4}
                  text-anchor="middle">
                  0
                </text>
                <text
                  font-family="Roboto"
                  x="50%"
                  y="103"
                  style="font-size: 36px"
                  class="svg-num"
                  text-anchor="middle">
                  /
                </text>
                <text
                  id={'svg-num-33'}
                  x="70%"
                  y="107"
                  font-family="Roboto"
                  class="svg-num fade-in-slow"
                  class:svg-num-7={orderer_initialized_orders_digits === 2}
                  class:svg-num-8={orderer_initialized_orders_digits === 3}
                  class:svg-num-9={orderer_initialized_orders_digits === 4}
                  text-anchor="middle">
                  0
                  <!--{$session.user.stats.orderer_initialized_orders}-->
                </text>
              {:else if hexa.name[0] === payments}
                <text />
              {:else}
                <text
                  id={'svg-num-' + i}
                  x="50%"
                  y="107"
                  font-family="Roboto"
                  class="svg-num fade-in"
                  class:svg-num-33={pp_digits === 6 && i === 0}
                  class:svg-num-7={pp_digits === 7 && i === 0}
                  class:svg-num-8={pp_digits === 8 && i === 0}
                  class:svg-num-9={pp_digits === 9 && i === 0}
                  text-anchor="middle">
                  0
                </text>
              {/if}
              {#each hexa.name as name, j}
                {#if j === 0}
                  <text
                    x="50%"
                    y={hexa.y_top}
                    class="svg-name slideUp"
                    dominant-baseline="middle"
                    text-anchor="middle">
                    {name}
                  </text>
                {:else if j === 1}
                  <text
                    x="50%"
                    y={hexa.y_bottom}
                    class="svg-name slideUp"
                    dominant-baseline="middle"
                    text-anchor="middle">
                    {name}
                  </text>
                {/if}
              {/each}

              {#if hexa.name[0] === payments}
                <image
                  class="animated bounceInLeft"
                  x="72"
                  y="45"
                  href={hexa.img}
                  width="70"
                  height="70" />
              {:else}
                <image
                  class="animated bounceInLeft"
                  x="50"
                  y="10"
                  href={hexa.img}
                  width="35"
                  height="35" />
              {/if}

            </svg>
          </a>
          <br />
        {/each}
      </div>
      <div>
        {#each orderer_hexas2 as hexa, i}
          <a data-link href={hexa.href} class="second-row">
            <svg
              width="210"
              height="182"
              viewbox="0 0 210 181.8653347947321"
              class={hexa.css}>
              <path
                class="hexa-stroke"
                d="M2.5000000000000004 95.26279441628824Q0 90.93266739736605
                2.5000000000000004 86.60254037844385L50 4.330127018922193Q52.5 0
                57.5 0L152.5 0Q157.5 0 160 4.330127018922193L207.5
                86.60254037844385Q210 90.93266739736605 207.5
                95.26279441628824L160 177.5352077758099Q157.5 181.8653347947321
                152.5 181.8653347947321L57.5 181.8653347947321Q52.5
                181.8653347947321 50 177.5352077758099Z" />
              <!--              <text-->
              <!--                id={'svg-num-' + (3 + i)}-->
              <!--                x="50%"-->
              <!--                y="107"-->
              <!--                font-family="Roboto"-->
              <!--                class="svg-num fade-in"-->
              <!--                class:svg-num-33={pp_digits === 6 && i === 0}-->
              <!--                text-anchor="middle">-->
              <!--                0-->
              <!--              </text>-->
              {#each hexa.name as name, j}
                {#if name === workers_map}
                  <!--{#if orderer_hexas2[0]}}-->
                  <image
                    class="animated bounceInLeft"
                    x="72"
                    y="45"
                    href={hexa.img}
                    width="70"
                    height="70" />
                {:else}
                  <image
                    class="animated bounceInLeft"
                    x="62"
                    y="40"
                    href={hexa.img}
                    width="85"
                    height="85" />
                {/if}

                {#if j === 0}
                  <text
                    x="50%"
                    y={hexa.y_top}
                    class="svg-name slideUp"
                    dominant-baseline="middle"
                    text-anchor="middle">
                    {name}
                  </text>
                {:else if j === 1}
                  <text
                    x="50%"
                    y={hexa.y_bottom}
                    class="svg-name slideUp"
                    dominant-baseline="middle"
                    text-anchor="middle">
                    {name}
                  </text>
                {/if}
              {/each}
            </svg>
          </a>
          <br />
        {/each}
      </div>
      <div class="hexa-history">
        {#each orderer_hexas3 as hexa, i}
          <a data-link href={hexa.href}>
            <svg
              width="210"
              height="182"
              viewbox="0 0 210 181.8653347947321"
              class={hexa.css}>
              <path
                class="hexa-stroke"
                d="M2.5000000000000004 95.26279441628824Q0 90.93266739736605
                2.5000000000000004 86.60254037844385L50 4.330127018922193Q52.5 0
                57.5 0L152.5 0Q157.5 0 160 4.330127018922193L207.5
                86.60254037844385Q210 90.93266739736605 207.5
                95.26279441628824L160 177.5352077758099Q157.5 181.8653347947321
                152.5 181.8653347947321L57.5 181.8653347947321Q52.5
                181.8653347947321 50 177.5352077758099Z" />
              <text
                id={'svg-num-4'}
                x="50%"
                y="107"
                font-family="Roboto"
                class="svg-num fade-in"
                class:svg-num-33={pp_digits === 6 && i === 0}
                class:svg-num-7={pp_digits === 7 && i === 0}
                class:svg-num-8={pp_digits === 8 && i === 0}
                class:svg-num-9={pp_digits === 9 && i === 0}
                text-anchor="middle">
                0
              </text>
              {#each hexa.name as name, j}
                {#if name === workers_map}
                  <!--{#if orderer_hexas2[0]}}-->
                  <image
                    class="animated bounceInLeft"
                    x="72"
                    y="45"
                    href={hexa.img}
                    width="70"
                    height="70" />
                {:else}
                  <image
                    class="animated bounceInLeft"
                    x="50"
                    y="10"
                    href={hexa.img}
                    width="35"
                    height="35" />
                {/if}

                {#if j === 0}
                  <text
                    x="50%"
                    y={hexa.y_top}
                    class="svg-name slideUp"
                    dominant-baseline="middle"
                    text-anchor="middle">
                    {name}
                  </text>
                {:else if j === 1}
                  <text
                    x="50%"
                    y={hexa.y_bottom}
                    class="svg-name slideUp"
                    dominant-baseline="middle"
                    text-anchor="middle">
                    {name}
                  </text>
                {/if}
              {/each}
            </svg>
          </a>
          <br />
        {/each}
      </div>
    {:else}
      {#each worker_hexas as hexa, i}
        <a data-link href={hexa.href}>
          <svg
            width="210"
            height="182"
            viewbox="0 0 210 181.8653347947321"
            class={hexa.css}>
            <path
              class="hexa-stroke"
              d="M2.5000000000000004 95.26279441628824Q0 90.93266739736605
              2.5000000000000004 86.60254037844385L50 4.330127018922193Q52.5 0
              57.5 0L152.5 0Q157.5 0 160 4.330127018922193L207.5
              86.60254037844385Q210 90.93266739736605 207.5
              95.26279441628824L160 177.5352077758099Q157.5 181.8653347947321
              152.5 181.8653347947321L57.5 181.8653347947321Q52.5
              181.8653347947321 50 177.5352077758099Z" />
            {#if hexa.name[0] === payments}
              <text />
            {:else}
              <text
                id={'svg-num-' + i}
                x="50%"
                y="107"
                font-family="Roboto"
                class="svg-num fade-in"
                text-anchor="middle">
                0
              </text>
            {/if}
            {#each hexa.name as name, j}
              {#if j === 0}
                <text x={hexa.x_top} y={hexa.y_top} class="svg-name slideUp">
                  {name}
                </text>
              {:else if j === 1}
                <text
                  x={hexa.x_bottom}
                  y={hexa.y_bottom}
                  class="svg-name slideUp">
                  {name}
                </text>
              {/if}
            {/each}

            {#if i !== 0}
              <image
                class="animated bounceInLeft"
                x="50"
                y="10"
                href={hexa.img}
                width="35"
                height="35" />
            {:else}
              <image
                class="animated bounceInLeft"
                x="72"
                y="45"
                href={hexa.img}
                width="70"
                height="70" />
            {/if}
          </svg>
        </a>
        <br />
      {/each}
    {/if}
  </main>
</div>

<style type="text/scss">
  /* Define theme variables before importing any MDC Web component styles */
  :root {
    --pageMax: 1024px;
  }

  .mdc-fab {
    width: 75px;
    height: 75px;
    padding: 0;
    /*border: #fff solid 3px;*/
    /*background-color: #06b0f4;*/
    background-color: var(--home-hexa-apps-hover);
  }

  .material-icons.md-order-size {
    font-size: 45px;
  }

  .new-order-text {
    margin-top: 5px;
    display: block;
    color: white;
    font-weight: bold;
    text-shadow: 0px 1px 4px #000000;
  }

  a:link {
    color: white;
    text-decoration: none;
  }

  /* visited link */
  a:visited {
    color: white;
    text-decoration: none;
  }

  a,
  a:active,
  a:focus {
    outline: none;
  }

  .svg-num {
    font-family: Roboto, Arial;
    fill: white;
    font-size: 40pt;
  }

  .svg-num-32 {
    font-family: Roboto, Arial;
    fill: white;
    font-size: 33pt;
  }

  .svg-num-33 {
    font-family: Roboto, Arial;
    fill: white;
    font-size: 33pt;
  }

  .svg-num-7 {
    font-family: Roboto, Arial;
    fill: white;
    font-size: 30pt;
  }

  .svg-num-8 {
    font-family: Roboto, Arial;
    fill: white;
    font-size: 28pt;
  }

  .svg-num-9 {
    font-family: Roboto, Arial;
    fill: white;
    font-size: 25pt;
  }

  .currency {
    font-family: Roboto, Arial;
    fill: white;
    font-size: 35pt;
  }

  .svg-name {
    font-family: Roboto, Arial;
    fill: white;
    font-size: 14pt;
  }

  .hidden {
    visibility: hidden;
  }

  .pp-digit-6 {
    font-size: 35pt;
  }

  #svg-num-3 {
    display: none;
  }

  .hexa-history {
    margin-left: 0px;
    margin-top: -170px;
  }

  /* Desktop Mode
  *******************************************************/
  @media (min-width: 769px) {
    .home-hexagons {
      text-align: center;
      /*  min-height: 2000px;
      overflow: hidden; */
      padding: 44px 0 0 18px;
    }

    .hexa-pos-top {
      position: relative;
      top: -100px;
    }

    .hexa-pos-left {
      left: 40px;
    }

    .hexa-pos-right {
      right: 40px;
    }

    .hexa-pos-left2 {
      left: -68px;
    }

    .hexa-pos-right2 {
      right: -68px;
    }

    .hexa-margin-top {
      margin-top: 100px;
    }

    br {
      display: none !important;
    }

    .new-order-container {
      margin-bottom: -85px;
    }

    .second-row {
      top: 14px;
      position: relative;
    }
  }

  /* Mobile Mode
  *******************************************************/

  @media (min-width: 0) and (max-width: 768px) {
    .hexa-margin-mobile-lg {
      margin-top: 100px;
    }

    .hexa-margin-mobile-sm {
      margin-top: 10px;
    }

    .new-order-container {
      margin-bottom: -85px;
    }

    .home-hexagons {
      text-align: center;
      min-height: 2000px;
      overflow: hidden;
      padding: 44px 0 0 18px;
    }

    .hexa-history {
      margin-top: 0;
      margin-left: 0;
    }
  }

  /* Effects
  ***************/

  .svg-mask {
    clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);
    /*https://bennettfeely.com/clippy/ */
  }

  .grow {
    transition: all 0.2s ease-in-out;
  }

  .grow:hover {
    transform: scale(1.05);
  }

  .bounceInDown {
    -webkit-animation-name: bounceInDown;
    animation-name: bounceInDown;
  }

  .jelatin {
    -webkit-animation: jelatin;
    -moz-animation: jelatin;
    -o-animation: jelatin;
    animation: jelatin;
    -webkit-animation-duration: 0.5s;
    -moz-animation-duration: 0.5s;
    -o-animation-duration: 0.5s;
    animation-duration: 0.5s;
    -webkit-animation-delay: 0;
    -moz-animation-delay: 0;
    -o-animation-delay: 0;
    animation-delay: 0;
    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  @keyframes jelatin {
    from,
    to {
      opacity: 1;
    }

    25% {
      -webkit-transform: scale(0.9, 1.1);
      -moz-transform: scale(0.9, 1.1);
      -ms-transform: scale(0.9, 1.1);
      transform: scale(0.9, 1.1);
    }

    50% {
      -webkit-transform: scale(1.1, 0.9);
      -moz-transform: scale(1.1, 0.9);
      -ms-transform: scale(1.1, 0.9);
      transform: scale(1.1, 0.9);
    }

    75% {
      -webkit-transform: scale(0.95, 1.05);
      -moz-transform: scale(0.95, 1.05);
      -ms-transform: scale(0.95, 1.05);
      transform: scale(0.95, 1.05);
    }
  }

  @keyframes bounceInDown {
    0% {
      opacity: 0;
      transform: translateY(-2000px);
    }
    50% {
      opacity: 0;
      transform: translateY(-2000px);
    }
    56% {
      opacity: 1;
      transform: translateY(30px);
    }
    58% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(0);
    }
    90% {
      transform: translateY(0);
    }
    92% {
      opacity: 1;
      transform: translateY(30px);
    }
    100% {
      opacity: 0;
      transform: translateY(-2000px);
    }
  }
</style>
